import React from "react";
import { Col, Container, Row } from "reactstrap";

import CardRequestsStatsCard from "./components/StatsCard";
import QuickLinks from "./components/QuickLinks"
import PageHeader from "../../shared/components/PageHeader";
import CardProgrammeCard from "./components/CardProgrammeCard";
import AccessControl from "../../shared/components/AccessControl";
import { permissionsConstants } from "../../constants/permissions.constants";

const Dashboard = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
      
        <PageHeader header="Dashboard" />
      </Col>
    </Row>
    <Row>
        <Col md={12} xl={3} lg={6} xs={12}>
          <CardRequestsStatsCard />
        </Col>
        <AccessControl
          allowedPermissions={[permissionsConstants.VIEW_ALL]}
        >
          <Col md={12} xl={3} lg={6} xs={12}>
            <CardProgrammeCard />
          </Col>
        </AccessControl>
        
    </Row>
    <Row>
      <QuickLinks />
    </Row>
  </Container>
);

export default Dashboard;
